import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TRootState } from "../../../../../store";
import useAxiosClient from "../../../../../hooks/useAxiosClient";

const useStep1 = () => {

    const { adminId, payout, selectedBeneficiary } = useSelector((state: TRootState) => ({
        adminId: state.auth.adminId,
        payout: state.payout.payout,
        selectedBeneficiary: state.beneficiary.selectedBeneficiary
    }))

    const { handleGetCall } = useAxiosClient();

    const [avlBal, setAvlBal] = useState(0);

    useEffect(() => {
        if (avlBal == 0) {
            getAvaliableBalance();
        }
    }, []);

    const getAvaliableBalance = () => {
        handleGetCall(`payments/payouts/avlBal/adminId/${adminId}`).then((data) => {
            if (data) {
                setAvlBal(Number(data.data));
            }
        });
    };

    return {
        avlBal,
        payout,
        selectedBeneficiary
    }
}
export default useStep1; 